/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./scripts');
require('./map');

import { createApp } from 'vue';
import Swiper from "swiper/bundle";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import _ from "lodash";
window._ = _;

const app = createApp({
  mounted() {
    const verslides = document.querySelectorAll(".verticalBanners .swiper-slide").length;
    const vc = document.getElementById("idverticalBanners");
    const caja1 = document.querySelector(".swiper-slide:nth-child(1)");
    const caja3 = document.querySelector(".swiper-slide:nth-child(3)");  
    let sspv;
    let cant; 

    if (window.innerWidth < 1260) {
      //Portrait Slideshow
      const verticalBanners = new Swiper(".verticalBanners", {
        noSwiping: false,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        breakpoints: {
          575: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 15,
          },
          1110: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 15,
          }
        },
        pagination: {
          el: ".vertical-banners-pagination",
          clickable: true,
        },
        on: {
          breakpoint: function (verticalBanners) {
            //Width en container swipe
            
            if (window.innerWidth >= 1110){
              sspv = 3
              
              if (verslides > sspv){
                cant = 300 * sspv + 15 * 2;
              }else{
                cant = 300 * verslides + 15 * (verslides - 1);
              }
              vc.style.width = cant + 'px';

            } else if (window.innerWidth >= 768){
              sspv = 2;

              if (verslides > sspv){
                cant = 300 * sspv + 15;
              }else{
                cant = 300 * verslides + 15;
              }
              vc.style.width = cant + 'px';

            } else{
              sspv = 1
              cant = 300;
              vc.style.width = cant + 'px';
            }
          }
        },
        navigation: false
      });
    }else{
      //Portrait DK 1260
      if(verslides === 4){
        if (caja1 || caja3) {
          caja1.style.setProperty('margin-right', '20px', 'important');
          caja3.style.setProperty('margin-right', '20px', 'important');
        }
      }   
    } 

    //Landscape Slideshow
      const horizontalSlides = document.querySelectorAll(".horizontalBanners .swiper-slide").length;
      const hc = document.getElementById("idhorizontalBanners");
      

      const horizontalBanners = new Swiper(".horizontalBanners", {
        noSwiping: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: true,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        updateOnWindowResize: true,
        breakpoints: {
          1260: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            centeredSlides: false
          },
        },
        pagination: {
          el: ".horizontal-banners-pagination",
          clickable: true,
        },
        on: {
          breakpoint: function (horizontalBanners) {
            //Width en container swipe

            if (window.innerWidth >= 1260) {
              sspv = 2
            } else{
              sspv = 1
            }

            if (horizontalSlides > sspv){
              cant = 620 * sspv + 15;
            }else{
              if(verslides === 1){
                cant = 620 * horizontalSlides;
              }else{
                cant = 620 * horizontalSlides + 15;
              }            
            }
            
            if (window.innerWidth >= 650) {
              hc.style.width = cant + 'px';
            }
          }
        },
        navigation: false
      }); 

  }
});

app.component('VueDatePicker', VueDatePicker);

app.component('chart-preview-component', require('./components/ChartPreviewComponent').default);
app.component('chart-full-component', require('./components/ChartFullComponent').default);
app.component('pronostico-clima', require('./components/PronosticoClimaComponent').default);
app.component('mapa-lluvias', require('./components/MapaLluviasComponent').default);
app.component('remates', require('./components/RematesComponent').default);
app.component('remates-proximos', require('./components/RematesProximosComponent').default);
app.component('remates-resultados', require('./components/RematesResultadosComponent').default);
app.component('remate-featured', require('./components/RemateFeaturedComponent').default);
app.component('custom-pagination', require('./components/CustomPagination').default);
app.component('multiselect', require('./components/Multiselect').default);
app.component('custom-select', require('./components/Select').default);

app.mount('#app');